const withQs = (url: string, qs: string) => {
  const q = url.indexOf('?') >= 0 ? '' : '?';
  const a = !!q ? '' : '&';
  return url + q + a + qs.replace(/^&/, '');
};

export default withQs;
